import { COLORS, SEMI_BOLD_FONT_WEIGHT } from "@/react/theme/constants";
import styled from "styled-components";
import Tooltip from "@8x8/oxygen-tooltip";
import React, { useState } from "react";
import { TrashIcon } from "@8x8/oxygen-icon/icons";
import { PencilInBoxIcon } from "@8x8/oxygen-icon";
import { IconButton } from "@8x8/oxygen-icon-button";
import { useLocation, useNavigate } from "react-router-dom";
import { useDeleteSipTrunkMutation } from "@/react/features/support-tools/siptrunk/api";
import { errorNotification } from "@/react/notifications";
import { ConfirmMessage } from "@/react/components/ConfirmMessage";
import { notify, TYPE } from "@8x8/oxygen-toaster";
import { OverlaySpinner } from "@/react/components/OverlaySpinner";

const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid ${COLORS.tertiary};
  border-radius: 4px;
  width: 100%;
  max-width: 1000px;
  :hover {
    background: ${COLORS.gray10};
    cursor: pointer;
  }
`;

const LeftSection = styled.div`
  display: flex;
  gap: 8px;
`;

const Index = styled.span`
  color: ${COLORS.secondary};
  margin-right: 8px;
`;

const Name = styled.span`
  font-weight: ${SEMI_BOLD_FONT_WEIGHT};
`;

const Brand = styled.span`
  color: ${COLORS.secondary};
  margin-left: 4px;
`;

const ProxyServer = styled.span`
  margin-left: 16px;
  font-size: 12px;
  font-family: monospace;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
`;

const IpBox = styled.span`
  margin-left: 12px;
`;

const IconButtonsContainer = styled.div`
  display: flex;
  gap: 4px;
  margin-left: 16px;
`;

const TrunkGatewayCard = ({
  index,
  trunkId,
  name,
  brand,
  proxyServer,
  ipBoxes,
  outboundIpBoxes,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [askDelete, setAskDelete] = useState(false);

  const [deleteTrunkGateway, { isLoading: isDeleting }] =
    useDeleteSipTrunkMutation();

  const navigateToEditPage = () => {
    navigate(`${location.pathname}/${trunkId}`);
  };

  const handleOpenDeleteConfirmation = (e) => {
    e.stopPropagation();
    setAskDelete(true);
  };

  const handleDelete = () => {
    setAskDelete(false);
    deleteTrunkGateway({ trunkId })
      .then(() => {
        notify({
          content: `Gateway ${name} deleted successfully.`,
          type: TYPE.success,
          duration: 5000,
        });
      })
      .catch(errorNotification);
  };

  return (
    <>
      {askDelete && (
        <ConfirmMessage
          type={"warning"}
          handleConfirm={handleDelete}
          handleInfirm={() => setAskDelete(false)}
          question={`Are you sure you want to delete Trunk Gateway ${name}?`}
          title={"Confirm action"}
        />
      )}
      {isDeleting && <OverlaySpinner />}
      <Card onClick={navigateToEditPage}>
        <LeftSection>
          <Index>{index}</Index>
          <Tooltip title={"Name"}>
            <Name>{name}</Name>
          </Tooltip>
          <span> / </span>
          <Tooltip title={"Brand"}>
            <Brand>{brand}</Brand>
          </Tooltip>
          <Tooltip title={"Proxy Server"}>
            <ProxyServer>{proxyServer}</ProxyServer>
          </Tooltip>
        </LeftSection>
        <RightSection>
          <IpBox>{ipBoxes} IP</IpBox>
          <IpBox>{outboundIpBoxes} Outbound IPs</IpBox>
          <IconButtonsContainer>
            <IconButton onClick={navigateToEditPage}>
              <PencilInBoxIcon />
            </IconButton>
            <IconButton onClick={handleOpenDeleteConfirmation}>
              <TrashIcon />
            </IconButton>
          </IconButtonsContainer>
        </RightSection>
      </Card>
    </>
  );
};

export default TrunkGatewayCard;
